import './Share.css'
import { RiGitRepositoryLine } from 'react-icons/ri'
import { BsCalendarEvent } from 'react-icons/bs'
import { MdOutlinePoll } from 'react-icons/md'
import { GrSend } from 'react-icons/gr'
import { useContext, useState } from 'react'
import AuthContext from '../../../context/AuthProvider'
import { AiFillCloseCircle } from 'react-icons/ai';
import { Navigate, useNavigate } from 'react-router-dom'
import { axiosInstance } from '../../../config.util'
export default function Share(){
    const {authState: user} = useContext(AuthContext)
    const [postContent, setPostContent] = useState('');
    const [isModalOpen, setisModalOpen] = useState(false);
    const navigate = useNavigate();

    // console.log('user and avatar share', user);

    document.getElementsByClassName('sw__input').readOnly = true;

    const handleSubmit = async (e) => {
        e.preventDefault();
        const data = { userId: user.id, desc: postContent };
              // api/users/623ca97dbae45693f15b788c
        try {
            await axiosInstance.post('/posts', data, {
                headers: {
                    "Authorization": `Bearer ${user.accessToken}`,
                },
            }).then((res)=>{
                navigate('/')
                // console.log('DONE');
            })
        } catch (error) {
            // console.log('ERROR');
        }
      }
    return(
        <div className="share">
            <div className="share__wrapper">
                <div className="share__writer">
                    <img className='sw__profileImg' src={user.avatar} alt="profile" />
                    <input type="text" className='sw__input' placeholder='Share with the world' onClick={()=>setisModalOpen(true)}/>
                    {
                        isModalOpen?(
                            <div className="input__modal">
                            <AiFillCloseCircle className='__modal-close'  onClick={()=>setisModalOpen(false)}/>
                            <form class="container" onSubmit={handleSubmit}>
                                <textarea type="text" id="textbox" placeholder="What's happening?" required value={postContent} onChange={(e)=>setPostContent(e.target.value)}></textarea>
                                <div id="counterFooter">140/140</div>
                                <button id="btn">Share</button>
                            </form>
                        </div>
                        ):null
                    }
                </div>
                <div className='divider'></div>
                <div className="s__wrapper">
                    <div className="share__write-wrapper">
                        <div className="share__write-links">
                            <div className="shareOpt-link">
                                < BsCalendarEvent />
                            </div>
                            <div className="shareOpt-link">
                                < RiGitRepositoryLine className='share_link-gitrepo' />
                            </div>
                            <div className="shareOpt-link">
                                < MdOutlinePoll className='share_link-poll' />
                            </div>
                        </div>
                        <button className="shareOpt-btn">
                            <div className="shareOpt-btn-icon">
                                <GrSend />
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}